
export default {
    loading(state){
        return state.loading
    },

    list(state){
        return state.list
    },

    emptyBox(state){
        return state.emptyBox
    }
}